<div class="col-sm-12" x-report-history="" x-config="config"></div>
